import React from 'react';

const ToHTML = ({ html, component = 'span' }) => {
  const Comp = component;
  return <Comp dangerouslySetInnerHTML={{ __html: html }} />;
};

export default ToHTML;
